import React, { useState } from "react";
import "./MasterclassPage.css";

const MasterclassPage = () => {
  const [activeCategory, setActiveCategory] = useState("hap");
  const [openVideo, setOpenVideo] = useState(null);

  const categories = {
    hap: [
      { id: 1, title: "Balmumu ve Çiçekmum - 1", src: "https://www.youtube.com/embed/KlLGrCdBMbU" },
      { id: 2, title: "Balmumu ve Çiçekmum - 2", src: "https://www.youtube.com/embed/pUMAdQ2m6B8" },
      { id: 3, title: "Beher, Kazan, Mat Kullanımı ve Temizliği", src: "https://www.youtube.com/embed/FzmUEe4InfQ" },
      { id: 4, title: "Kesici ya da Kaşık ile Boylama Nasıl Yapılmalı", src: "https://www.youtube.com/embed/r7ib0x91z2Y" },
      { id: 5, title: "Sap Yapımı ve Renklerin Karıştırılabilmesi", src: "https://www.youtube.com/embed/-Livj4zw7pc" },
      { id: 6, title: "Ütüleme Nasıl Yapılmalı, Yaprak Montajlarında Dikkat Edilecekler", src: "https://www.youtube.com/embed/AmTjcx0_B8k" },
     { id: 7, title: "Çiçek Kozmetiğinde Dikkat Edilecekler", src: "https://www.youtube.com/embed/G7RYch0V2IU" },
    ],
    baslangic: [
      { id: 8, title: "Teknik Bilgiler ve Şakayık Modeli", src: "https://www.youtube.com/embed/j6pS5Two1fY" },
      { id: 9, title: "Gül Modeli", src: "https://www.youtube.com/embed/HlhO7Xjkb3k" },
      { id: 10, title: "Lale Modelleri", src: "https://www.youtube.com/embed/SVTjwdqvL_I" },
      { id: 11, title: "Gala Çiçeği Modeli", src: "https://www.youtube.com/embed/SbYmcporm9Y" },
      { id: 12, title: "Açık Yaprak Şakayık Modeli", src: "https://www.youtube.com/embed/7uLGGjlaACQ" },
      { id: 13, title: "Düğün Çiçeği Modeli", src: "https://www.youtube.com/embed/mLda3BSBvYI" },
      { id: 14, title: "Sümbül Modeli", src: "https://www.youtube.com/embed/PTRkF5aH2gs" },
      { id: 15, title: "Kamelya Modeli", src: "https://www.youtube.com/embed/Mj7q9zfxW-k" },
    ],
    ileri: [
      { id: 16, title: "Erengül Modeli", src: "https://www.youtube.com/embed/GGLi0xyzVPk" },
    ],
  };

  const renderVideos = (list) =>
    list.map((v) => (
      <div key={v.id} className="accordion-item">
        <button
          className="accordion-title"
          onClick={() => setOpenVideo(openVideo === v.id ? null : v.id)}
        >
          {v.title}
        </button>

        {openVideo === v.id && (
          <div className="accordion-content">
            <iframe
              width="100%"
              height="315"
              src={v.src}
              title={v.title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        )}
      </div>
    ));

  return (
    <div className="masterclass-container">
      <h1>Masterclass Eğitim Videoları</h1>

      <div className="category-tabs">
        <button
          className={activeCategory === "hap" ? "active" : ""}
          onClick={() => { setActiveCategory("hap"); setOpenVideo(null); }}
        >
          Hap Bilgiler
        </button>

        <button
          className={activeCategory === "baslangic" ? "active" : ""}
          onClick={() => { setActiveCategory("baslangic"); setOpenVideo(null); }}
        >
          Başlangıç Seviye
        </button>

        <button
          className={activeCategory === "ileri" ? "active" : ""}
          onClick={() => { setActiveCategory("ileri"); setOpenVideo(null); }}
        >
          İleri Seviye
        </button>
      </div>

      <div className="video-list">
        {renderVideos(categories[activeCategory])}
      </div>
    </div>
  );
};

export default MasterclassPage;
